import moment from 'moment';
import { getMomentDateStringFromRangeArray } from '@/utils/dateUtil';
import { PPA_SOURCE_API } from '@/api';

const state = {
  tableData: [],
};

const actions = {
  async fetchPPALossData({ commit }, parameters = {}) {
    const { startDate, endDate } = getMomentDateStringFromRangeArray(parameters.tradeDateRangeSelected);
    const params = {
      ppas: parameters.ppasSelected,
      startDate,
      endDate,
    };
    try {
      const { data: { data } } = await PPA_SOURCE_API.post('/reservation/losses/get', params);
      if (Array.isArray(data)) {
        data.forEach((x) => {
          x.tradingDate = moment(x.tradingDate).utc().format('MM/DD/YYYY');
        });
        commit('setTableData', data);
      }
    } catch (err) {
      console.error(err);
      this.$notify('Failed to load Losses Data', 'error');
    }
  },
};

const mutations = {
  setTableData(state, value) {
    state.tableData = value;
  },
  reset(state) {
    state.tableData = [];
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};